var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4937 15.1875V15.0375H14.3438H13.2188H13.0688V15.1875V16.1625H4.0875V4.93125H5.0625H5.2125V4.78125V3.65625V3.50625H5.0625H2.8125H2.6625V3.65625V17.4375V17.5875H2.8125H14.3438H14.4937V17.4375V15.1875Z",
    fill: "#FFC535",
    stroke: "#FFC535",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 0.4125H6.0375V0.5625V14.0625V14.2125H6.1875H17.4375H17.5875V14.0625V5.39202V5.32989L17.5436 5.28595L12.714 0.456434L12.6701 0.4125H12.608H6.1875ZM10.9688 7.18125H16.1625V12.7875H7.4625V1.8375H10.8187V7.03125V7.18125H10.9688ZM12.2438 2.0014L15.9986 5.75625H12.2438V2.0014Z",
    fill: "#FFC535",
    stroke: "#FFC535",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.142fcd40082a832f79d989fccd65c51a.svg";
export { ForwardRef as ReactComponent };